import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from './store/store'
import { RootCmp } from './root-cmp'
import './assets/styles/main.scss'
import { GoogleOAuthProvider } from '@react-oauth/google';

// The app always uses the Monday dark colourway (no light mode / no toggle).
document.body.classList.add('theme-dark')
// Restore the user's Task-column width (drag-resizable, Monday-style)
document.documentElement.style.setProperty('--task-col-w', localStorage.getItem('taskColW') || '336px')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "1012532250356-ud3tfm78a98ltl1vkujo0oaq8mqrec7q.apps.googleusercontent.com"}>
    <Provider store={store}>
      <Router>
        <RootCmp />
      </Router>
    </Provider>
  </GoogleOAuthProvider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Unregister the service worker — its aggressive caching kept serving stale builds.
serviceWorkerRegistration.unregister();
// Aggressively remove ANY previously-registered SW + its caches, so an old worker can
// never serve a stale build again (this was the root of the recurring "not fixed" issue).
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister())).catch(() => { })
}
if (typeof caches !== 'undefined') {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => { })
}